import { decomposeColor } from '@mui/material/styles';
import { ContactCaptureSettings } from '../types';
import { createDefaultContactCaptureSettings } from './contactCaptureSettings';

const NEW_CAPTURE_BRAND = '#254597';
const NEW_CAPTURE_BACKGROUND = '#ffffff';
const NEW_CAPTURE_TEXT = '#212121';

/** Settings may store brand colors as rgb()/rgba(); translucent ones make no sense as a fill. */
const toOpaqueHex = (color?: string): string | null => {
  if (!color) return null;
  try {
    const { type, values } = decomposeColor(color);
    if (!type.startsWith('rgb') || (values[3] !== undefined && values[3] < 1)) return null;
    return `#${values.slice(0, 3).map(value => Math.round(value).toString(16).padStart(2, '0')).join('')}`;
  } catch {
    return null;
  }
};

/**
 * New captures start in the application's brand color, the one Settings uses for buttons.
 * Saved captures are normalized from their own styles and never pass through here.
 */
export const createBrandedContactCaptureSettings = (brandColor?: string): ContactCaptureSettings => {
  const settings = createDefaultContactCaptureSettings();
  const brand = toOpaqueHex(brandColor) || NEW_CAPTURE_BRAND;
  settings.styles = {
    ...settings.styles,
    primaryColor: brand,
    buttonColor: brand,
    backgroundColor: NEW_CAPTURE_BACKGROUND,
    textColor: NEW_CAPTURE_TEXT,
  };
  return settings;
};
